import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Card, 
  CardContent 
} from '@mui/material';
import { BarChart } from '@mui/icons-material';
import { getPageTitle } from '../config/branding';

const AnalyticsPage = () => {
  React.useEffect(() => {
    document.title = getPageTitle('Analytics');
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Analytics & Progress
        </Typography>
        <Typography variant="body1" color="text.secondary">
          View your step progress, challenge performance, and fitness trends
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              py: 6
            }}
          >
            <BarChart sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" component="h2" gutterBottom>
              Analytics Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Connect your devices and join challenges to see detailed analytics and progress tracking.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AnalyticsPage;